import React, { FC, useState, useEffect } from "react";
import Button from "../atoms/Button";

import MainLayout from "../../Layouts/MainLayout";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Spinner from "../atoms/Spinner";
import { service } from "../../../services/AxiosServices";
import SectionHeader from "../molecules/SectionHeader";
import WindowHeightComponent from "../../Layouts/WindowHeight";

interface Overview {
  agent_name: string;
  description: string;
}

const FineTuneOverview: FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [overViews, setOverviews] = useState<Overview[]>([]);
  const [ok, setOk] = useState<Record<string, any> | null>(null);
  const [feedbackSaved, setFeedbackSaved] = useState<Record<string, any> | null>(null);

  const [loading, setLoading] = useState<boolean>(false);
  const [isSubmitting, setSubmitting] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const location = useLocation();
  const navigate = useNavigate();
  const { response, id, crewName } = location.state || {};
  const { taskId } = useParams();
  // Fetches overview data based on taskId and response status from the API
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const endpoint = response
          ? "api/response-overview"
          : "api/finetune-overview";
        const res = await service<{ responses: any }>(
          endpoint,
          "post",
          { task_id: taskId },

        );

        const mappedData = res?.data?.responses.map((ele: any) => ({
          agent_name: ele.agent_name,
          description: ele.response,
        }));
        setOverviews(mappedData);
        setError(null);
      } catch (err: any) {
        console.log(err)
        const errorMessage = err?.response?.data?.error || "Something went wrong. Please try again..";

        setError(errorMessage);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id, response]);
  // Handles modal open/close actions for adding feedback
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setFeedback("");
  };
  // Submits feedback to the server and navigates to the appropriate page upon success
  const handleSaveFeedback = async () => {
    try {

      const apiData = await service<Record<string, any>>(
        "api/submit-feedback",
        "post",
        { task_id: taskId, feedback }
      );
      console.log(apiData.data)

      setFeedbackSaved(apiData.data);




      navigate(`/response/${id}`, { state: { crewName } });
    } catch (err) {
      console.log(err);
    } finally {
      setSubmitting(false)
    }
    navigate(`/finetune_response/${id}`);
    setIsModalOpen(false);
    setFeedback("");
  };

  const handleClick = async () => {
    try {
      setSubmitting(true)
      const apiData = await service<any>(
        `api/update-finetune-status`,
        'post',
        {
          task_id: taskId,
          status: true,
        },

      );
      console.log(apiData.data)

      setOk(apiData.data);

      navigate(`/response/${id}`, { state: { crewName } });
    } catch (err) {
      console.log(err);
    } finally {
      setSubmitting(false)
    }
  };

  return (
    <>
      <MainLayout>

        <SectionHeader back={true} title={`Crew: ${crewName}`} />

        <WindowHeightComponent className={""}>
          <div className="p-3">
            {loading ? (
              <Spinner />
            ) : error ? (
              <div className="alert alert-danger text-center mt-3">{error}</div>
            ) : (
              <div className="p-3">
                <div className="row">
                  {overViews.map((overview, index) => (
                    <div className="border p-3" key={index}>
                      <div className="Title-finetune mb-3">{overview.agent_name}</div>
                      <pre style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
                        {overview.description}
                      </pre>

                    </div>
                  ))}
                  {!response && (
                    <div className="d-flex justify-content-end mt-2 p-0">

                      <Button className="btn SaveBtn  me-2" onClick={handleOpenModal}>
                        Add
                      </Button>

                      <Button
                        className="btn SaveBtn"
                        onClick={handleClick}
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        ) : (
                          "Confirm"
                        )}
                      </Button>
                    </div>
                  )}
                </div>

              </div>
            )}
          </div>
        </WindowHeightComponent>

      </MainLayout>

      {isModalOpen && (
        <div
          className="modal d-block"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Feedback</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseModal}
                ></button>
              </div>
              <div className="modal-body">
                <textarea
                  className="form-control"
                  rows={4}
                  placeholder="Enter your feedback here..."
                  value={feedback}
                  onChange={(e) => setFeedback(e.target.value)}
                />
              </div>
              <div className="modal-footer">
                <Button
                  className="btn btn-secondary"
                  onClick={handleCloseModal}
                >
                  Cancel
                </Button>
                <Button
                  className="btn SaveBtn"
                  onClick={handleSaveFeedback}
                >
                  {isSubmitting ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    "Send"
                  )}
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FineTuneOverview;
